import Repository from './Repository'

const resource = 'levels'

export default {
  getLevels () {
    return Repository.get(`${resource}`, {
      params: {
        'include[0]': 'lessons'
      }
    })
  }
}
